module.exports = __webpack_public_path__ + "static/media/dizzy.8b5ce351.svg";